import React from 'react'
import BulkProdTable from '../../component/productsComps/ProductTable/BulkProdTable'
import InformationHeader from '../../component/reusable/informationHeader/InformationHeader'
import { useSelector } from 'react-redux';

const BulkProdUpload = () => {
  const { bulkUploadData,loading } = useSelector((state) => state.products);
  
  return (
    <div>
    <InformationHeader
    mainpage="Dashboard"
    prevpage="Bulk Product Upload"
    pagename="Add Product"
    buttonText="Save"
  />
        <BulkProdTable   bulkUploadData={bulkUploadData} loading={loading}/>
    </div>
  )
}

export default BulkProdUpload